import { IntlShape, MessageDescriptor } from 'react-intl';

import { FeatureFlag } from 'protocol/model/dto_organization_pb';

import { featureFlagsDefaultMessages } from '@/shared/config/i18n';

// The backend can ship a flag before this admin build knows its label.
export const getFeatureFlagLabel = (
  flag: FeatureFlag,
  formatMessage: IntlShape['formatMessage'],
): string => {
  const descriptor: MessageDescriptor | undefined =
    featureFlagsDefaultMessages[flag];

  return descriptor
    ? formatMessage(descriptor)
    : FeatureFlag[flag] ?? String(flag);
};
